module.exports = __webpack_public_path__ + "img/share_txt_pp.23146655.png";